module.exports = __webpack_public_path__ + "static/img/appdow_bk3_dt.5dec755.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/appdow_bk3_dt.gif
// module id = OglC
// module chunks = 4